import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { generateStockCorrectionReport } from './Report.service';
import { StockCorrectionReportRequest } from './Report.types';

export function useGenerateStockCorrectionReport() {
  const mutation = useMutation(
    (obj: StockCorrectionReportRequest) => generateStockCorrectionReport(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Relatório gerado com sucesso!',
          description: 'Relatório de Correção de Estoque gerado com sucesso',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
